"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
const BaseMessage_1 = require("./BaseMessage");
class Query extends BaseMessage_1.BaseMessage {
    getLogType() {
        return 'request';
    }
}
exports.Query = Query;
